class Modal {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $(function() {
      $('.c-modal-trigger').modaal({
          type: 'image',
          animation_speed: 300,
          background: '#fff',
	        overlay_opacity: '0.5',
      });
    });
  }
}